import React from "react";
import ReactDOM from "react-dom";
class TableRow extends React.Component {
  componentDidMount() {
    this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getRowMenuItems([this.props.index], () => {
      this.props.contextMenu.update(this._listenerId);
    }), this.props.contextMenu.RIGHT_CLICK);
  }
  componentDidUpdate() {
    this.props.contextMenu.removeListener(this._listenerId);
    this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getRowMenuItems([this.props.index], () => {
      this.props.contextMenu.update(this._listenerId);
    }), this.props.contextMenu.RIGHT_CLICK);
  }
  componentWillUnmount() {
    this.props.contextMenu.removeListener(this._listenerId);
  }
  onMouseOver = () => {
    if (this.props.onRowHover) {
      this.props.onRowHover(this.props.index);
    }
  };
  render() {
    return /*#__PURE__*/React.createElement("div", {
      draggable: true,
      onDragStart: event => {
        if (this.props.onDragStart) {
          this.props.onDragStart(this.props.index, event);
        }
      },
      onClick: event => this.props.onSelect(this.props.index, this.props.rowData, event),
      className: this.props.className,
      key: this.props.rowKey,
      style: this.props.style,
      onMouseOver: this.onMouseOver
    }, this.props.columns, this.props.hoverButton);
  }
}
export default TableRow;